import { z } from 'zod';
export const EmailInboxStatusSchema = z.enum([
    'RECEIVED',
    'PROCESSED',
    'PARTIAL',
    'QUARANTINED',
    'FAILED',
    'SKIPPED',
]);
const aliasField = z
    .string()
    .min(1)
    .max(64)
    .transform((s) => s.trim().toLowerCase());
export const EmailIntakeRouteCreateSchema = z.object({
    alias: aliasField,
    companyId: z.uuid(),
    active: z.boolean().default(true),
});
export const EmailIntakeRouteSchema = z.object({
    id: z.uuid(),
    alias: z.string(),
    companyId: z.uuid(),
    active: z.boolean(),
    createdAt: z.string(),
});
export const EmailSenderAllowlistCreateSchema = z.object({
    // exact address "billing@pea.co.th" OR a domain "@pea.co.th".
    pattern: z.string().min(3).max(254),
    companyId: z.uuid().nullable().default(null),
    vendorId: z.uuid().nullable().default(null),
    note: z.string().max(255).nullable().default(null),
    active: z.boolean().default(true),
});
export const EmailSenderAllowlistSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid().nullable(),
    pattern: z.string(),
    vendorId: z.uuid().nullable(),
    note: z.string().nullable(),
    active: z.boolean(),
    createdAt: z.string(),
});
export const EmailInboxMessageSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid().nullable(),
    providerMessageId: z.string(),
    rfc822MessageId: z.string().nullable(),
    fromAddress: z.string(),
    toAlias: z.string().nullable(),
    subject: z.string().nullable(),
    receivedAt: z.string().nullable(),
    spfPass: z.boolean(),
    dkimPass: z.boolean(),
    dmarcPass: z.boolean(),
    senderTrusted: z.boolean(),
    status: EmailInboxStatusSchema,
    reason: z.string().nullable(),
    attachmentCount: z.number().int().nonnegative(),
    ingestedCount: z.number().int().nonnegative(),
    createdAt: z.string(),
});
// Mailbox connection status for the settings page.
export const EmailIntakeStatusSchema = z.object({
    enabled: z.boolean(),
    mailbox: z.string().nullable(),
    lastPollAt: z.string().nullable(),
    hasCursor: z.boolean(),
    lastError: z.string().nullable(),
});
//# sourceMappingURL=email-intake.js.map